module.exports = __webpack_public_path__ + "static/media/bomb-fire.9c15b4b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/game/bomber/bomb/bomb-fire.svg
// module id = 27
// module chunks = 0